// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3qs67","loaderOuter":"PageOverlayLoader_loaderOuter__6hyWh"};